import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const SingleSignOnConfiguration = () =>
  import(
    /* webpackChunkName: "SingleSignOnConfiguration" */
    '@/views/configuration/singleSignOn/SingleSignOnConfiguration.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'singleSignOn',
  treeViewKey: TreeViewConstants.Keys.Configuration
};

export const SingleSignOnRoutes = [
  {
    ...Configuration.SingleSignOn.Management,
    components: {
      default: SingleSignOnConfiguration,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
